/**
 * Types of removable chips created from autocomplete fields in EditableLabel
 */
export function HistoryChangeType() {}
HistoryChangeType.creation = 1;
HistoryChangeType.edition = 2;
HistoryChangeType.deletion = 3;
HistoryChangeType.childCreation = 4;
HistoryChangeType.childEdition = 5;
HistoryChangeType.childDeletion = 6;

export default HistoryChangeType;
